import Http from "./Http";

export class ConversationsService extends Http {
  /**
   * Get conversation by id
   * @param {number} id
   */
  getConversation(id) {
    return this.get(`/conversations/${id}`);
  }

  /**
   * Get conversations by ids
   * @param {Array<number>} conversationsIds
   */
  getConversationsByIds(params) {
    return this.get(`/conversations/details`, { params });
  }

  /**
   * Get list of conversations
   * @param {object} params
   * @param {number} params.limit
   * @param {string} params.offset
   */
  getConversations(params) {
    return this.get("/conversations", { params });
  }

  /**
   * Get conversation messages
   * @param {number} id
   * @param {object} params
   * @param {number} params.limit
   * @param {string} params.cursor
   * @param {string} params.direction 1 - NEXT, 2 - PREVIOUS
   */
  getConversationMessages(id, params) {
    return this.get(`/conversations/${id}/messages`, { params });
  }

  /**
   * Hide coversationById
   * @param {number} id conversation id
   */
  hideConversation(id) {
    return this.patch(`/conversations/${id}/is-hide`);
  }

  /**
   * Send message to conversation
   * @param {number} id
   * @param {Object} body
   * @param {string} body.text message content
   */
  sendMessage(id, body) {
    return this.post(`/conversations/${id}/messages`, body);
  }

  /**
   * Mark all messages in this conversation as read
   * @param {number} id
   */
  readConversation(id) {
    return this.patch(`/conversations/${id}/is-read`);
  }

  /**
   * Get unread conversations count
   */
  getUnreadCount() {
    return this.get("/conversations/count");
  }
}

export default new ConversationsService();
